module.exports = {"341225101":"方集镇","341225102":"中岗镇","341225103":"柴集镇","341225104":"新村镇","341225106":"朱寨镇","341225107":"柳沟镇","341225108":"赵集镇","341225109":"田集镇","341225110":"苗集镇","341225111":"黄岗镇","341225112":"焦陂镇","341225113":"张寨镇","341225114":"王堰镇","341225115":"地城镇","341225116":"洪河桥镇","341225117":"王家坝镇","341225118":"王化镇","341225119":"曹集镇","341225120":"鹿城镇","341225121":"会龙镇","341225200":"王店孜乡","341225201":"许堂乡","341225204":"段郢乡","341225205":"公桥乡","341225206":"龙王乡","341225207":"于集乡","341225208":"老观乡","341225209":"郜台乡","341225401":"安徽阜南经济开发区","341225500":"阜濛农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341225.json
// module id = 1125
// module chunks = 0